import { get } from 'lodash';
import { EXTERNAL_GROUP_TYPE } from '../constants';

export default function isExternalProvider(group) {
  return get(group, 'group_type') === EXTERNAL_GROUP_TYPE;
}
